const parseBackendFileErrorResponse = (message) => {
  let parsed;
  try {
    parsed = JSON.parse(message)?.row || JSON.parse(message)?.Row;
  } catch (e) {
    parsed = false;
  }
  return { value: parsed || message, parsed: !!parsed };
};

export default parseBackendFileErrorResponse;